<template>
  <v-dialog v-model="dialog" fullscreen content-class="fullscreen-dialog">
    <Header :headTitle="title" isShowBackBtn @clickBack="cancel" />

    <div class="detail-page">
      <!-- <DetailHeader btnType="close" :title="title" @headerCloseClick="cancel" /> -->
      <!-- <v-tabs v-model="tab" fixed-tabs @change="changeTab">
        <v-tab key="terms"> 이용약관 </v-tab>
        <v-tab key="policy"> 개인정보처리방침 </v-tab>
        <v-tab key="marketing"> 마케팅 동의 </v-tab>
      </v-tabs> -->

      <!-- 이용약관 -->
      <Terms v-if="tab === 'term'" />


      <!-- 개인정보처리방침  -->
      <Policy v-if="tab === 'policy'" />


      <!-- 마케팅 동의 -->
      <Marketing v-if="tab === 'marketing'" />

    </div>
  </v-dialog>
</template>

<script>
import DetailHeader from "@/_bayer/commonComp/DetailHeader.vue";
import Marketing from "@/_bayer/commonComp/policy/Marketing.vue";
import Policy from "@/_bayer/commonComp/policy/Policy.vue";
import Terms from "@/_bayer/commonComp/policy/Terms.vue";
import Header from "@/_bayer/commonComp/Header.vue";
export default {
  components: {
    DetailHeader,
    Terms,
    Policy,
    Marketing,
    Header
  },
  props: {},
  data() {
    return {
      dialog: false,
      tab: null,
      title: "",
    };
  },
  methods: {
    open(_tab) {
      this.tab=_tab;
      switch (_tab) {
        case "term":
          this.title = "이용약관";
          break;
        case "policy":
          this.title = "개인정보처리방침";
          break;
        case "marketing":
          this.title = "마케팅 동의";
          break;
      }
      // this.changeTab(this.tab);

      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.$emit("clickCancel");
    },
    changeTab(e) {
      console.log(e);
      switch (e) {
        case 0:
          this.title = "이용약관";
          break;
        case 1:
          this.title = "개인정보처리방침";
          break;
        case 2:
          this.title = "마케팅 동의";
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.v-dialog.fullscreen-dialog {
  background: #ffffff;
  .agree-content  {
    width: 90vw;
    margin: 0 auto;
    overflow: auto;
    height: calc(100vh - 77px);
  }

  .v-tabs {
    position: relative;
    left: -1rem;
    width: 100vw;
    border-bottom: 1px solid var(--gray-light-2);

    .v-slide-group__prev {
      display: none !important;
    }

    .v-tab.v-tab--active {
      background: var(--gray-light-2);
    }
  }

  .v-tabs-items {
    margin-top: 1rem;
    font-size: 14px;
  }
}
</style>